export default function HydrogenHero() {
  return (
    <section className="relative min-h-[88vh] flex items-center overflow-hidden pt-16">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Futuristic%20green%20hydrogen%20production%20facility%20with%20large%20electrolysers%20and%20storage%20tanks%20next%20to%20solar%20and%20wind%20farm%20in%20Australian%20landscape%2C%20dramatic%20blue%20sky%2C%20industrial%20clean%20energy%20infrastructure%2C%20cinematic%20aerial%20photography%2C%20advanced%20technology%2C%20epic%20scale%2C%20premium%20editorial%20energy%20photography&width=1800&height=900&seq=hydrogen-hero-au-2026&orientation=landscape"
          alt="Green hydrogen production facility powered by renewable energy in Australia"
          className="w-full h-full object-cover object-center"
        />
        {/* Strong left-to-right dark ramp so text area is nearly opaque */}
        <div className="absolute inset-0 bg-gradient-to-r from-black/97 via-black/90 to-black/60" />
        {/* Top + bottom fade for depth */}
        <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-transparent to-black/50" />
      </div>

      <div className="relative w-full max-w-7xl mx-auto px-4 md:px-6 lg:px-10 py-20 md:py-28">
        {/* Backdrop panel behind text for guaranteed contrast */}
        <div
          className="max-w-3xl rounded-2xl"
          style={{
            background: 'linear-gradient(135deg, rgba(0,0,0,0.50) 0%, rgba(0,0,0,0.20) 100%)',
            backdropFilter: 'blur(4px)',
            WebkitBackdropFilter: 'blur(4px)',
            padding: '2rem 2rem 2rem 2rem',
          }}
        >
          {/* Text shadow applied to entire text container — inherited by all children */}
          <div style={{ textShadow: '0 2px 20px rgba(0,0,0,0.90), 0 1px 6px rgba(0,0,0,0.75)' }}>
            <nav aria-label="Breadcrumb" className="flex items-center gap-2 mb-6">
              <a href="/" className="text-xs text-white/70 hover:text-white transition-colors whitespace-nowrap">Home</a>
              <i className="ri-arrow-right-s-line text-white/40 text-xs"></i>
              <span className="text-xs text-white/85 whitespace-nowrap">Hydrogen Energy Australia</span>
            </nav>

            <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-accent-500/25 border border-accent-400/40 mb-6">
              <i className="ri-test-tube-line text-accent-300 text-sm"></i>
              <span className="text-xs font-semibold text-accent-200 tracking-wide uppercase whitespace-nowrap">Hydrogen Energy Solutions Australia</span>
            </div>

            <h1 className="font-heading text-4xl md:text-5xl lg:text-6xl font-extrabold tracking-tight leading-[1.08] text-white mb-6">
              Hydrogen Energy<br />
              Solutions<br />
              <span className="text-accent-400">Australia</span>
            </h1>

            <p className="text-lg md:text-xl text-white leading-relaxed mb-4 max-w-2xl">
              Australia is positioned to become the world&rsquo;s leading green hydrogen exporter. Discover hydrogen energy solutions, providers, and investment opportunities — from green hydrogen production to industrial applications and export projects.
            </p>

            <p className="text-sm md:text-base text-white/80 leading-relaxed mb-8 max-w-xl">
              AK Energy connects businesses, project developers, and investors with Australia&rsquo;s growing hydrogen energy ecosystem — backed by the National Hydrogen Strategy and $2B in federal government funding.
            </p>

            <div className="flex flex-col sm:flex-row gap-3">
              <a
                href="/#contact"
                className="whitespace-nowrap inline-flex items-center justify-center gap-2 px-7 py-3.5 text-sm font-semibold rounded-xl bg-primary-500 text-white hover:bg-primary-400 transition-all duration-200 cursor-pointer"
              >
                Find Hydrogen Energy Providers
                <i className="ri-arrow-right-line text-lg"></i>
              </a>
              <a
                href="/#contact"
                className="whitespace-nowrap inline-flex items-center justify-center gap-2 px-7 py-3.5 text-sm font-semibold rounded-xl bg-white/15 border border-white/30 text-white hover:bg-white/25 transition-all duration-200 cursor-pointer backdrop-blur-sm"
              >
                <i className="ri-file-list-3-line text-lg"></i>
                Explore Hydrogen Projects
              </a>
            </div>

            <div className="flex flex-wrap items-center gap-6 mt-10 pt-8 border-t border-white/20">
              {[
                { icon: 'ri-government-line', text: 'National Hydrogen Strategy Backed' },
                { icon: 'ri-rocket-line', text: '$2B Hydrogen Headstart Program' },
                { icon: 'ri-ship-2-line', text: 'Export-Ready Projects' },
              ].map((item) => (
                <div key={item.text} className="flex items-center gap-2">
                  <i className={`${item.icon} text-accent-300 text-base`}></i>
                  <span className="text-xs text-white/85 font-medium whitespace-nowrap">{item.text}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}